module.exports = __webpack_public_path__ + "img/schedule_send_black_24dp 1greenShareArrow.86b7f79e.svg";